var _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSummaryReceived(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.07406 10.6745C5.92864 11.016 6.00112 11.4116 6.25856 11.6793L12.332 17.9985C12.5067 18.1803 12.7478 18.283 13 18.283C13.2522 18.283 13.4933 18.1803 13.668 17.9985L19.7414 11.6793C19.9989 11.4116 20.0714 11.016 19.9259 10.6745C19.7805 10.3328 19.4449 10.111 19.0737 10.111H17.0371V1.43416C17.0371 0.922706 16.6225 0.507812 16.1108 0.507812H9.88921C9.37752 0.507812 8.96286 0.922706 8.96286 1.43416V10.111H6.92634C6.55507 10.111 6.21947 10.3328 6.07406 10.6745Z",
    fill: "#677070"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 22,
    width: 26,
    height: 3,
    rx: 1,
    fill: "#677070"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryReceived);
export default __webpack_public_path__ + "static/media/summary-received.8167d2586a3968d434e369d3850bedad.svg";
export { ForwardRef as ReactComponent };